"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prHeaderFooterService', [
        '$sanitize',
        'prPageHeaderFooterGenerator',
        'prActiveReport',
        'prPageLayoutService',
        'prHiddenRenderer',
        'prFlowingPages',
        'prEventService',
        function ($sanitize, headerFooterGenerator, activeReport, pageLayout, hiddenRenderer, flowingPages, eventService) {
            var HEADER_FOOTER = 'headerFooter';
            var DEFAULT_QUILL_DELTA = {
                ops: [
                    {
                        insert: '\n'
                    }
                ]
            };
            var DEFAULTS = {
                header: {
                    calculatedHeight: 96,
                    logo: {
                        height: 0.5,
                        alignment: 'none',
                        type: 'BRAND'
                    },
                    pageNumber: {
                        alignment: 'none'
                    },
                    timezone: {
                        alignment: 'none'
                    },
                    customTitle: {
                        alignment: 'left',
                        content: '',
                        formats: {
                            FONT: 'times',
                            SIZE: 10,
                            COLOR: '#222222'
                        }
                    },
                    quillObject: DEFAULT_QUILL_DELTA,
                    html: ''
                },
                footer: {
                    calculatedHeight: 96,
                    logo: {
                        height: 0.5,
                        alignment: 'none',
                        type: 'BRAND'
                    },
                    pageNumber: {
                        alignment: 'none'
                    },
                    timezone: {
                        alignment: 'none'
                    },
                    customTitle: {
                        alignment: 'left',
                        content: '',
                        formats: {
                            FONT: 'times',
                            SIZE: 10,
                            COLOR: '#222222'
                        }
                    },
                    quillObject: DEFAULT_QUILL_DELTA,
                    html: ''
                }
            };
            var CELL_SIZE = pageLayout.getCellSize();
            var properties;
            function getProperties(noClone) {
                if (properties) {
                    return noClone ? properties : lodash_1.default.cloneDeep(properties);
                }
                properties = lodash_1.default.defaultsDeep({}, activeReport.getMetadata(HEADER_FOOTER) || {}, DEFAULTS);
                // Make sure html and height run at least once, don't want to use cached value
                properties.header.html = headerFooterGenerator.getHeaderFooterHTML(properties.header);
                properties.footer.html = headerFooterGenerator.getHeaderFooterHTML(properties.footer);
                properties.header.calculatedHeight = getUpdatedHeight(properties.header.html);
                properties.footer.calculatedHeight = getUpdatedHeight(properties.footer.html);
                return properties;
            }
            function setProperties(props) {
                properties = lodash_1.default.cloneDeep(props);
                return activeReport.setMetadata(HEADER_FOOTER, props);
            }
            function getProperty(prop, noClone) {
                return getProperties(noClone)[prop];
            }
            function isDisabled(headerFooter) {
                return !headerFooter.html;
            }
            function getPXHeight(prop) {
                var headerFooter = getProperty(prop, true);
                var height = headerFooter.calculatedHeight;
                // Round height to cell size
                if (height / CELL_SIZE !== 0) {
                    height = Math.ceil(height / CELL_SIZE) * CELL_SIZE;
                }
                return isDisabled(headerFooter) ? 0 : height;
            }
            function getUpdatedHeight(html) {
                var preview = $('<pr-page-header-footer>')
                    .css('width', pageLayout.getWidth())
                    .html(html);
                hiddenRenderer.appendElement(preview);
                var calculatedHeight = preview.height();
                preview.remove();
                return calculatedHeight;
            }
            function updateHeaderOrFooter(headerFooter, headerFooterLayout) {
                var options = headerFooterLayout[headerFooter];
                options.calculatedHeight = getUpdatedHeight(options.html);
                setProperties(headerFooterLayout);
                flowingPages.updateWidgetScale();
                eventService.trigger(headerFooter + 'ConfigChanged');
            }
            function updateHeaderAndFooter() {
                var headerFooterLayout = getProperties();
                lodash_1.default.forEach(headerFooterLayout, function (options, headerFooter) {
                    updateHeaderOrFooter(headerFooter, headerFooterLayout);
                });
            }
            return {
                getProperties: getProperties,
                setProperties: setProperties,
                getProperty: getProperty,
                isDisabled: isDisabled,
                getPXHeight: getPXHeight,
                updateHeaderOrFooter: updateHeaderOrFooter,
                updateHeaderAndFooter: updateHeaderAndFooter
            };
        }
    ]);
})(angular_1.default.module('qualtrics.pr'));
